import { Brick, registerBrick } from 'olympe';
import { getApplicationContext } from '../../common/utils/Context.js';
import { getLogger } from '@olympeio/core';

export default class GetRowSelectionStatus extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array} inputs
     * @param {function(boolean)} setRowSelectionStatus
     */
    update($, inputs, [setRowSelectionStatus]) {
        let logger = getLogger('GetRowSelectionStatus')
        const applicationContext = getApplicationContext($);
        const selectedBCP = applicationContext.get("selectedBCPs")
        logger.info(
            'selected BCP from Application Context', selectedBCP
        );
        if (selectedBCP?.length === 0 || null === selectedBCP) {
            logger.info(":: length of selected value is zero")
            setRowSelectionStatus(false)
        } else {
            logger.info(":: length of selected value is: ", selectedBCP?.length)
            setRowSelectionStatus(true)
        }
    }
}

registerBrick('019b8df20fa868890bfd', GetRowSelectionStatus);
